import makeBoundUrl from 'redux-addressbar'
import c from 'state/constants'
import {setAppModule, setBrNr, setB2bCompanyBrNr, setOpenedSubmenu, setClientSubModule,	setB2bCompanySubModule,
    setB2BInsuranceCompany, setEmailDocumentId, setAccountConfirmationHash, changeAuthState, setDSDocumentsOpened, setDSDocumentsSubModule, setDSDocumentsOpenedPackage } from 'state/actions'
import JSURL from 'jsurl'

export const locs = {
	news: c.NEWS,
	inbox: c.INBOX,
	tasklist: c.TASKLIST,
	outbox: c.OUTBOX,
	agenda: c.AGENDA,
	links: c.LINKS,
	clients: c.CLIENTS,
	production: c.PRODUCTION,
	b2b: c.B2B,
	insuranceCompany: c.INSURANCE_COMPANY,
	insuranceCompany2320: c.PVVERZEKERINGENCVBA,
	insuranceCompany2321: c.GENERALIBELGIUM,
	claims: c.CLAIMS,
	contracts: c.CONTRACTS,
	profile: c.PROFILE,
	willdoc: c.WILLDOC,
	office: c.OFFICE,
	login: c.LOGIN,
	faq: c.FAQ,
	webapps: c.WEBAPPS,
	emaildocument: c.EMAILDOCUMENT,
	accountConfirmation: c.ACCOUNT_CONFIRMATION,
    dsdocuments: c.DSDOCUMENTS,
    privacy: c.PRIVACY,
	404: c.NOT_FOUND,
}

const reverseLocs = {}
Object.keys(locs).forEach(k => {reverseLocs[locs[k]] = k})

const loc2action = (loc, store = {}) => (dispatch) => {
    const [module, param, subParam, subParam2] = loc.pathname.slice(1).split('/').map(decodeURIComponent)
    const search = loc.search ? JSURL.parse(decodeURIComponent(loc.search.slice(1))) : ''
    let component = locs[module]
    let hash
    if(module === 'accountConfirmation' && param && param.length > 0)
    {
        hash = param;
    }


	switch (component) {
		case c.NEWS:
		case c.CLAIMS:
		case c.OFFICE:
			dispatch(setBrNr(search.brNr))
			break
		case c.CLIENTS:
			dispatch(setOpenedSubmenu(subParam2))
			dispatch(setClientSubModule(subParam))
            break
        // this for loading data for insurance company when opened module by link... in the future we have to use this
        /* case c.GENERALIBELGIUM:
            dispatch(setB2BInsuranceCompany({companyId:submenuItem.dataCargo, insuranceCompany: submenuItem.menuLabel}))
        case c.PVVERZEKERINGENCVBA:
            dispatch(setB2BInsuranceCompany({companyId:submenuItem.dataCargo, insuranceCompany: submenuItem.menuLabel}))*/
        case c.INSURANCE_COMPANY:
		case c.GENERALIBELGIUM:
		case c.PVVERZEKERINGENCVBA:
			dispatch(setB2bCompanyBrNr(search.brNr))
			dispatch(setB2bCompanySubModule(subParam))
            break
        case c.EMAILDOCUMENT:
            dispatch(setEmailDocumentId(param))
            break
        case c.DSDOCUMENTS:
            dispatch(setDSDocumentsOpenedPackage(subParam2))
		    dispatch(setDSDocumentsSubModule(subParam))
			break
		case c.ACCOUNT_CONFIRMATION:
            if(hash){
                dispatch(changeAuthState('accountConfirmation'))
                dispatch(setAccountConfirmationHash(hash))
            }
            break
        case c.PRIVACY:
                dispatch(setAppModule(component))
            break
		case undefined:
			component = c.NOT_FOUND
			break
		default:
	}

    // Metro UI
    if (module === '') {
        component = undefined
    }

    if(component === c.ACCOUNT_CONFIRMATION){
	    dispatch(setAppModule(component))

    }else{
	    dispatch(setAppModule(component, param))
    }
}

const state2location = state => {
	const {module, opened, submenuOpened, brNr, openedPackage} = state.app
	const {subModule, subModuleZoom} = state.clients
	const b2bCompanySubModule = state.b2bCompany.subModule
	const b2bCompanySubModuleZoom = state.b2bCompany.subModuleZoom
	const b2bCompanyOpened = state.b2bCompany.opened
	const component = reverseLocs[state.app.module] || ''
	const search = {}
	let param
	let subParam
    let subParam2
	if (module === c.NEWS) {param = opened}
	if (module === c.OFFICE) {
		param = opened || 'general'
		if (brNr) {
			search.brNr = `${brNr}`
		}
	}
	if (module === c.CLAIMS) {
		param = opened
	}
	if (module === c.CONTRACTS) {
		param = opened
	}
	if (module === c.PROFILE) {
		param = opened
	}
	if (module === c.CLIENTS) {
		param = opened
		if (subModule) { subParam = subModule }
		if (submenuOpened) { subParam2 = submenuOpened }

		// This logic is also in clientContractsZoom, keep in sync.
		// TODO if we implement a derivation layer after the store, put this there
		if (!subParam2 && subModuleZoom && subModule === 'contracts') {
			const {contracts} = state
			const key = Object.keys(subModuleZoom)[0]
			if (key) {
				const value = subModuleZoom[key]
				let contract
				for (const cId of Object.keys(contracts)) {
					if (contracts[cId][key] === value) {
						contract = contracts[cId]
					}
				}
				subParam2 = contract && contract.contractId
			}
		}
    }
    if (module === c.DSDOCUMENTS) {
        if (state.DSDocuments.subModule) { subParam = state.DSDocuments.subModule }
		if (state.DSDocuments.opened) { subParam2 = state.DSDocuments.opened }
		if (state.DSDocuments.openedPackage) { subParam2 = state.DSDocuments.openedPackage }
		param = opened || openedPackage
	}
    // This is affected all of the insurance companies, all of them use a single general module
    const insCompaniesList = [c.INSURANCE_COMPANY, c.PVVERZEKERINGENCVBA, c.GENERALIBELGIUM]
	if (insCompaniesList.includes(module)) {
		param = b2bCompanyOpened
		if (b2bCompanySubModule) { subParam = b2bCompanySubModule }
		if (submenuOpened) { subParam2 = submenuOpened }
		if (!subParam2 && b2bCompanySubModuleZoom && b2bCompanySubModule === 'contracts') {
			const {contracts} = state
			const key = Object.keys(b2bCompanySubModuleZoom)[0]
			if (key) {
				const value = b2bCompanySubModuleZoom[key]
				let contract
				for (const cId of Object.keys(contracts)) {
					if (contracts[cId][key] === value) {
						contract = contracts[cId]
					}
				}
				subParam2 = contract && contract.contractId
			}
		}
	}
	if (component && param) {
		param = `/${encodeURIComponent(param)}`
	} else {
		param = ''
	}
	if (subParam) {
		subParam = `/${encodeURIComponent(subParam)}`
	} else {
		subParam = ''
	}
	if (subParam2) {
		subParam2 = `/${encodeURIComponent(subParam2)}`
	} else {
		subParam2 = ''
    }
	return {
		pathname: `/${component}${param}${subParam}${subParam2}`,
		// Don't use search until redux-addressbar fixes push/pop behavior
		// search: `?${JSURL.stringify(search)}`,
	}
}

export default store => makeBoundUrl({
	store,
	fromLoc: loc2action,
	toLoc: state2location,
})



// WEBPACK FOOTER //
// ./state/location.js